import axios from 'axios'

// initial state
const state = () => ({
  AccountId: null,
  AccountName: null
})

// getters
const getters = {}

// actions
const actions = {
  SignIn ({ commit }, value) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/Auth/SignIn', value)
        .then(response => {
          if (response.data.Success) {
            // Save JWT
            localStorage.setItem('irent-token', response.data.Token)
            localStorage.setItem('irent-Id', response.data.Id)
            localStorage.setItem('irent-Name', response.data.Name)
            commit('UserDataRefresh')
          } else {
            resolve(response.data)
          }
        })
        .catch(error => {
          console.log(error.message)
          reject(error)
        })
    })
  },
  SignOut ({ commit }) {
    localStorage.removeItem('irent-token')
    localStorage.removeItem('irent-Id')
    localStorage.removeItem('irent-Name')
    commit('UserDataClear')
    commit('categorys/Clear', true, { root: true })
    commit('orders/Clear', true, { root: true })
    commit('products/Clear', true, { root: true })
  },
  CheckAuth ({ commit }) {
    axios
      .post('/api/Auth/CheckAuth')
      .then(response => {})
      .catch(error => {
        console.log(error.message)
      })
  },
  SignRefresh ({ commit }) {
    commit('UserDataRefresh')
  },
  GetMemberInfo ({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/Auth/GetMemberInfo')
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          console.log(error.message)
          reject(error)
        })
    })
  },
  SSO ({ commit }, value) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/Auth/SSO', value)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          console.log(error.message)
          reject(error)
        })
    })
  },
  SSORedirect ({ commit }, value) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/Auth/SSORedirect', value)
        .then(response => {
          if (response.data.Success) {
            // let encrypted = response
            // Save JWT
            localStorage.setItem('irent-token', response.data.Token)
            localStorage.setItem('irent-Id', response.data.Id)
            localStorage.setItem('irent-Name', response.data.Name)
            commit('UserDataRefresh')
            // 呼叫 /api/Auth/TicketsInUse
            axios
              .post('/api/Auth/TicketsInUse', { memrfnbr: response.data.AccountId }, {
                headers: {
                  'Content-Type': 'application/json'
                }
              })
              .then(ticketsResponse => {
                // 檢查 ticketsResponse.data 是否有資料
                if (ticketsResponse.data && Object.keys(ticketsResponse.data).length > 0) {
                  // 將 tickets-in-use 資料寫入 localStorage
                  localStorage.setItem('tickets-in-use', JSON.stringify(ticketsResponse.data))
                } else {
                  // 如果 ticketsResponse.data 是 undefined 或空白，則清除 localStorage 中的 tickets-in-use
                  localStorage.removeItem('tickets-in-use')
                }
                resolve(response.data)
              })
              .catch(ticketsError => {
                console.log(ticketsError.message)
                reject(ticketsError)
              })
          }
          resolve(response.data)
        })
        .catch(error => {
          console.log(error.message)
          reject(error)
        })
    })
  }
}

// mutations
const mutations = {
  // 從webStore取得使用者資訊
  UserDataRefresh (state) {
    state.AccountId = localStorage.getItem('irent-Id')
    state.AccountName = localStorage.getItem('irent-Name')
  },
  // 清除使用者資訊
  UserDataClear (state) {
    state.AccountId = null
    state.AccountName = null
  }
}

// function Encrypt(content) {
//   return content;
// }

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
